export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'FollowupEmailConfig';
export const NAME = 'FollowupEmailConfig';
export const CRUMB_LABEL_EDIT = 'edtFollowupEmailConfig';
export const CRUMB_LABEL_LIST = 'grdFollowupEmailConfig';
